/**
 * Mirrors com.medprompt.consultation.dto.ConsultationUpdateRequest.
 * A partial update: the server treats null as "no change", so only the fields the caller set are
 * written. Nested update bodies are passed through as given.
 *
 * @param {string} consultationId
 * @param {object|null} [updateFields]
 * @returns {object}
 */
export function toConsultationUpdateRequest(consultationId, updateFields) {
  if (typeof consultationId !== 'string' || !consultationId) {
    throw new Error('ConsultationUpdateRequest: consultationId is required');
  }
  const fields = updateFields || {};
  const body = { consultationId };
  if (fields.nhsId !== undefined) body.nhsId = fields.nhsId;
  if (fields.existingPatientCodes !== undefined) body.existingPatientCodes = fields.existingPatientCodes;
  if (fields.newCodes !== undefined) body.newCodes = fields.newCodes;
  if (fields.measurements !== undefined) body.measurements = fields.measurements;
  if (fields.outcomeTasks !== undefined) body.outcomeTasks = fields.outcomeTasks;
  if (fields.notes !== undefined) body.notes = fields.notes;
  if (fields.templateId !== undefined) body.templateId = fields.templateId;
  if (fields.notesMode !== undefined) body.notesMode = fields.notesMode;
  if (fields.detailsUpdate !== undefined) body.detailsUpdate = fields.detailsUpdate;
  if (fields.existingCodeUpdate !== undefined) body.existingCodeUpdate = fields.existingCodeUpdate;
  if (fields.deletedExistingCodes !== undefined) body.deletedExistingCodes = fields.deletedExistingCodes;
  if (fields.newCodeUpdate !== undefined) body.newCodeUpdate = fields.newCodeUpdate;
  if (fields.deletedNewCodes !== undefined) body.deletedNewCodes = fields.deletedNewCodes;
  if (fields.measurementUpdate !== undefined) body.measurementUpdate = fields.measurementUpdate;
  if (fields.taskUpdate !== undefined) body.taskUpdate = fields.taskUpdate;
  return body;
}
